<template>
    <router-link :to=to class="btn btn-outline-secondary" :class="size">
        <i class="bi" :class="icon"></i>
        {{ text }}
    </router-link>
</template>


<script>
export default {
    name: 'ButtonBack',
    props: {
        text: {
            type: String,
            default: '戻る',
        },
        icon: {
            type: String,
            default: 'bi-reply',
        },
        type: {
            type: String,
            default: 'button',
        },
        to: {
            type: Object,
            default: () => {
                return {
                    name: null,
                    params: null,
                };
            }
        },
        size: {
            type: String,
            default: ''
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
